import useTranslation from "../../hooks/useTranslation";

function getTranslation(translationArray, keyToTranslate) {
  const translatedValue = useTranslation(translationArray, keyToTranslate);
  return translatedValue;
}

export { getTranslation };
